import type { LevelerCalibrationDto, PhoneFacing } from '@camper-diary/shared';

/**
 * Lettura grezza dell'inclinometro, nel riferimento del TELEFONO.
 *
 * Convenzione degli assi (schermo verso l'alto):
 *   x → bordo destro    y → bordo alto    z → fuori dallo schermo
 * Appoggiato in piano: z circa +9.81, x e y circa 0.
 */
export type TiltReading = {
  /** gradi, positivo quando il bordo destro dello schermo scende */
  roll: number;
  /** gradi, positivo quando il bordo alto dello schermo scende */
  pitch: number;
  /** true quando il telefono è fermo da abbastanza tempo da potersi fidare */
  steady: boolean;
  /** vettore gravità filtrato, serve alla calibrazione */
  raw: { x: number; y: number; z: number };
};

/** Lettura nel riferimento del CAMPER: roll > 0 = lato SINISTRO più in alto,
 *  pitch > 0 = MUSO più in alto. */
export type CamperTilt = { roll: number; pitch: number; steady: boolean };

/**
 * Dal riferimento del telefono a quello del camper.
 *
 * Con il telefono girato verso la coda entrambi gli assi si invertono, perché è
 * una rotazione di 180 gradi attorno alla verticale.
 */
export function toCamper(
  reading: TiltReading,
  calibration: LevelerCalibrationDto | null,
  phoneFacing: PhoneFacing,
): CamperTilt {
  let roll = reading.roll;
  let pitch = reading.pitch;

  if (calibration) {
    roll -= calibration.offsetRoll;
    pitch -= calibration.offsetPitch;
  }

  // Bordo destro che scende = lato sinistro più alto: il segno del rollio coincide
  // già. Il beccheggio invece si inverte: bordo alto che scende significa muso
  // più basso.
  const flip = phoneFacing === 'rear' ? -1 : 1;
  return { roll: roll * flip, pitch: -pitch * flip, steady: reading.steady };
}

/** Gradi con il segno meno tipografico: allo stesso corpo è più leggibile di un
 *  trattino, e in colonna non si confonde con un separatore. */
export function formatDeg(deg: number): string {
  return `${deg < 0 ? '−' : ''}${Math.abs(deg).toFixed(2)}°`;
}
